import Router from 'next/router';
import * as methods from '@binanceus/react-bridge-methods';
import { create, createBrowserAdapter } from '@binanceus/bridge';
// TODO(cmcheng): resolve it
// eslint-disable-next-line
import { auth } from '../actions/actionsSet/authcenter';
import { readCookie, createCookie } from './cookies-browser';
import { getLoginUrl } from './urlUtils';
// import { checkLogin } from './auth';
const { checkLogin } = require('./auth');

const customMethods = {
  ...methods,
  ensureLogged(params, callback) {
    const logined = readCookie('logined');
    if (logined === 'y') {
      callback({ alreadyLogged: true, logged: false });
    } else {
      const locale = window.location.pathname.match(/^\/(\w+)/)[1];
      window.location.href = getLoginUrl(locale, window.location.href);
    }
  },
  open(options) {
    const { path, link } = options;
    if (path) {
      Router.push(path);
    }
    if (link) {
      window.location.href = link;
    }
  },
  async isLogged(_, callback) {
    const data = await auth();
    const isLogined = data.success;
    if (!isLogined) {
      const { redirect, fallbackUrl } = checkLogin(window.location.pathname) || {};
      if (redirect) {
        const locale = window.location.pathname.match(/^\/(\w+)/)[1];
        window.location.href = getLoginUrl(locale, fallbackUrl);
      }
    } else {
      // update login status when login from other binance site
      createCookie('logined', 'y', 7, true);
    }
    callback({
      logged: data.success,
    });
  },
};

export default create(createBrowserAdapter(customMethods));
